import { Application, Controller } from "@hotwired/stimulus";

class ExportCsvController extends Controller {
  connect() {
    this.baseCheckboxes = {
      column_project_slug: false,
      column_project_title: false,
      column_customer_id: false,
      column_name: false,
      column_kana: false,
      column_email: false,
      column_birthday: false,
      column_postal_code: false,
      column_prefecture: false,
      column_city: false,
      column_building: false,
      column_phone_number: false,
      column_identity_verified: false,
      column_bank_code: false,
      column_bank_name: false,
      column_branch_code: false,
      column_branch_name: false,
      column_account_type: false,
      column_account_number: false,
      column_holder_name: false,
      column_purchase_amount: false,
      column_deposit_amount: false,
      column_paid_status: false,
      column_estimated_return_price: false,
      column_return_price: false,
      column_purchased_at: false,
      is_shift_jis: false,
      include_headers: false
    }
  }

  selectHarvestRevenueAttributes() {
    this.selectCheckboxes({
      column_bank_code: true,
      column_branch_code: true,
      column_account_type: true,
      column_account_number: true,
      column_holder_name: true,
      column_return_price: true,
      is_shift_jis: true,
      include_headers: false
    });
  }

  selectBlastMailAttributes() {
    this.selectCheckboxes({
      column_name: true,
      column_email: true,
      is_shift_jis: true,
      include_headers: true
    });
  }

  selectCheckboxes(checkboxes) {
    const attributes = {...this.baseCheckboxes, ...checkboxes};
    // 要素のIDを使ってチェックボックスを取得
    Object.keys(attributes).forEach(elementId => {
      document.getElementById(elementId).checked = attributes[elementId];
    })
  }
}

// Registered in admin.js
export { ExportCsvController };
